class InvalidateAndDeleteRvqImmunizationRequest {
    public MedicalItemId: string;
    public EmrTemplateId: string;
    public EmployeeId: string;
    public Note: string;

    public constructor(fields?: Partial<InvalidateAndDeleteRvqImmunizationRequest>) {
        Object.assign(this, fields);
    }
}

export { InvalidateAndDeleteRvqImmunizationRequest };
